import React from 'react';
import { NavLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import ArrowBackOutlined from '@mui/icons-material/ArrowBackOutlined';
import EditOffOutlined from '@mui/icons-material/EditOffOutlined';
import { EmptyState, PageHeader } from '@routes-plan/ui';
import { useT } from '../../../i18n';
import { setPageTitle } from '../../../utils/pageTitle';
import { pageSx } from '../components/layout';
import { ScreenTourButton } from '../../../components/help/ScreenHelp';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

/**
 * Los movimientos de caja no se editan: se eliminan el mismo día y se registran de nuevo.
 * Esta ruta mostraba un formulario de plantilla sin uso; ahora explica eso y lleva al listado.
 */
const ExpenseEdit: React.FC<ShowAlerts> = () => {
  const t = useT();
  setPageTitle('expenses.editTitle');
  return (
    <Box sx={pageSx}>
      <PageHeader
        title={t('expenses.editTitle')}
        breadcrumbs={[{ label: t('expenses.listTitle'), href: '#/loans/expenses' }, { label: t('expenses.editTitle') }]}
        helpAction={<ScreenTourButton />}
      />
      <Paper variant="outlined" data-tour="expense-edit-info">
        <EmptyState
          icon={<EditOffOutlined />}
          title={t('expenses.editUnavailableTitle')}
          description={t('expenses.editUnavailableDescription')}
          action={
            <Button variant="contained" startIcon={<ArrowBackOutlined />} component={NavLink} to="/loans/expenses" data-tour="expense-edit-back">
              {t('expenses.backToList')}
            </Button>
          }
        />
      </Paper>
    </Box>
  );
};

export default ExpenseEdit;
